import { Box, Heading } from '@razorpay/blade/components';
import xGrey from 'assets/mss/x-grey.svg';
import PreviewSalaryStructure from 'components/SalaryStructures/components/PreviewSalaryStructure';
import React from 'react';
import { useSalaryStructure } from '../hooks/useSalaryStructure';

const PreviewSelectedStructure = ({ isPreviewHidden = false }: { isPreviewHidden?: boolean }) => {
  const { earningComponents, nonPayableBenefitsComponents, variableComponents } =
    useSalaryStructure();

  return (
    <Box
      borderRadius={isPreviewHidden ? 'none' : 'medium'}
      borderWidth={isPreviewHidden ? 'none' : 'thin'}
      borderColor="surface.border.gray.muted"
      backgroundImage={`url("${xGrey}")`}
      backgroundRepeat="no-repeat"
      backgroundPosition="right bottom"
      height="100%"
      overflow="auto">
      <Box
        padding="spacing.6"
        gridTemplateRows="auto auto 1fr"
        display={isPreviewHidden ? 'none' : 'grid'}>
        <Heading weight="medium">Salary Structure Preview</Heading>

        <Box marginTop="spacing.7" overflow="auto">
          <PreviewSalaryStructure
            earningComponents={earningComponents}
            variableComponents={variableComponents}
            nonPayableBenefitsComponents={nonPayableBenefitsComponents}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewSelectedStructure;
